import { useState } from 'react'
import { Box, Typography, Paper, Tabs, Tab } from '@mui/material'
import {
  Notifications,
  Palette,
  Security,
  Devices,
  Home,
} from '@mui/icons-material'
import { NotificationSettings } from '../components/settings/NotificationSettings'
import { PreferencesSection } from '../components/settings/PreferencesSection'
import { SecuritySection } from '../components/settings/SecuritySection'
import { UserSessionsSection } from '../components/settings/UserSessionsSection'
import { BillingAddressSection } from '../components/settings/BillingAddressSection'

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState(0)

  const tabs = [
    { label: 'Location', icon: <Home />, component: <BillingAddressSection /> },
    { label: 'Preferences', icon: <Palette />, component: <PreferencesSection /> },
    { label: 'Notifications', icon: <Notifications />, component: <NotificationSettings /> },
    { label: 'Security', icon: <Security />, component: <SecuritySection /> },
    { label: 'Sessions', icon: <Devices />, component: <UserSessionsSection /> },
  ]

  return (
    <Box>
      {/* Header */}
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
        Settings
      </Typography>

      {/* Tabs */}
      <Paper elevation={0} sx={{ mb: 3, border: '1px solid', borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((tab, index) => (
            <Tab key={index} icon={tab.icon} label={tab.label} iconPosition="start" />
          ))}
        </Tabs>
      </Paper>

      {/* Tab Content */}
      <Box>{tabs[activeTab].component}</Box>

      {/* Build info */}
      <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mt: 4, textAlign: 'center' }}>
        Build: {new Date(__BUILD_DATE__).toLocaleDateString()}
      </Typography>
    </Box>
  )
}
